"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalendar = (state) => { var _a, _b, _c; return (_c = (_b = (_a = state) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.remoting) === null || _c === void 0 ? void 0 : _c.calendar; };
exports.getCalendarEvents = (state) => { var _a; return (_a = exports.getCalendar(state)) === null || _a === void 0 ? void 0 : _a.events; };
exports.getCalendarEnabled = (state) => { var _a; return (_a = exports.getCalendar(state)) === null || _a === void 0 ? void 0 : _a.enabled; };
exports.getCalendarUnsubscribed = (state) => { var _a; return (_a = exports.getCalendar(state)) === null || _a === void 0 ? void 0 : _a.unsubscribed; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/selectors/calendar.js
// module id = 533
// module chunks = 0